<!-- Header actions -->
<div class="content-center">
  <router-outlet name="overlay"></router-outlet>

  <app-reports-table-header
    [id]="id"
    [title]="title"
    [params]="params"
    [currentFilters]="filters"
    [currentColumnOptions]="columnOptions"
    (exportExcel)="exportExcel()"
    (exportCsv)="exportCsv()"
  ></app-reports-table-header>

  <wm-filter-builder
    #filterCtrl
    *ngIf="params"
    [id]="id"
    [params]="params"
    [filterTypes]="filterTypes"
    [showSimpleSearch]="false"
    [savedFilters]="true"
    [columnOptions]="columnOptions"
    [staffFilterBuilder]="true"
    (columnsChange)="onColumnsChanged($event)"
    (exportColumnsChange)="onExportColumnsChange($event)"
    (filtersChange)="onFiltersChanged($event)"
  ></wm-filter-builder>

  <!-- Table -->
  <div class="fees-table">
    <wm-common-table
      tableType="Staff"
      [columns]="columns"
      [data]="rows"
      [showRowsPerPage]="true"
      (exportColumnsChange)="onExportColumnsChange($event)"
      (sortChanged)="onSortChanged($event)"
      [serverSidePagination]="true"
      [totalPages]="page.totalPages"
      [showTotalRecords]="true"
      [totalRecords]="page.totalElements"
      [pageSizeStorageKey]="'report-fees-janus'"
      [currentPage]="page.pageNumber"
      [pageSize]="page.size"
      [isLoading]="loading"
      [loaderType]="'Circular'"
      [errorMessage]="errorMessage"
      (retry)="onRetry()"
      (pageChange)="onPageChange($event)"
      (rowsPerPageChange)="onRowsPerPageChange($event)"
    ></wm-common-table>
  </div>

  <!-- [showRowsPerPage]="true" -->
  <!-- <div class="overlay-backdrop"
      [class.show]="router.url.includes('scheduled-export')">

    <div class="overlay-panel" (click)="$event.stopPropagation()">
      <router-outlet></router-outlet>
    </div>
  </div> -->
</div>
